/* eslint-disable max-lines */
import { TIdToPageConfigMap } from 'models/common.model'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ22_V3 } from 'nove8/cohorts/woofz22_v3/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_22V4 } from 'nove8/cohorts/woofz22_v4/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_22V4_WT } from 'nove8/cohorts/woofz22_v4_wt/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_22V4_BG } from 'nove8/cohorts/woofz22_v4_bg/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_22V4T } from 'nove8/cohorts/woofz22_v4t/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_COACHING } from 'nove8/cohorts/woofz_coaching/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_EASTER_65 } from 'nove8/cohorts/woofz_easter/woofz_easter_65/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_EASTER_70 } from 'nove8/cohorts/woofz_easter/woofz_easter_70/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_EASTER_75 } from 'nove8/cohorts/woofz_easter/woofz_easter_75/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_EASTER_80 } from 'nove8/cohorts/woofz_easter/woofz_easter_80/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_ESA } from 'nove8/cohorts/woofz_esa/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_HLWN_65 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_65/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_HLWN_70 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_70/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_HLWN_75 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_75/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_HLWN_80 } from 'nove8/cohorts/woofz_hlwn/woofz_hlwn_80/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_INVX } from 'nove8/cohorts/woofz_invx/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_K9 } from 'nove8/cohorts/woofz_k9/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_K9_BL } from 'nove8/cohorts/woofz_k9_bl/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_K9_BL_BG } from 'nove8/cohorts/woofz_k9_bl_bg/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_K9_DRSL } from 'nove8/cohorts/woofz_k9_drsl/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_LOVE } from 'nove8/cohorts/woofz_love/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_LOVE_BL } from 'nove8/cohorts/woofz_love_bl/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD_65 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_65/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD_70 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_70/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD_75 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_75/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD_80 } from 'nove8/cohorts/woofz_ndd/woofz_ndd_80/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD } from 'nove8/cohorts/woofz_ndd/woofz_ndd_cohort/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_NPDAY_65 } from 'nove8/cohorts/woofz_npday/woofz_npday_65/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_NPDAY_70 } from 'nove8/cohorts/woofz_npday/woofz_npday_70/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_NPDAY_75 } from 'nove8/cohorts/woofz_npday/woofz_npday_75/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_NPDAY_80 } from 'nove8/cohorts/woofz_npday/woofz_npday_80/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_NRDAY_65 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_65/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_NRDAY_70 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_70/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_NRDAY_75 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_75/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_NRDAY_80 } from 'nove8/cohorts/woofz_nrday/woofz_nrday_80/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER1_65 } from 'nove8/cohorts/woofz_offer/woofz_offer1_65/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER1_70 } from 'nove8/cohorts/woofz_offer/woofz_offer1_70/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER1_75 } from 'nove8/cohorts/woofz_offer/woofz_offer1_75/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER1_80 } from 'nove8/cohorts/woofz_offer/woofz_offer1_80/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER2_70 } from 'nove8/cohorts/woofz_offer/woofz_offer2_70/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER2_75 } from 'nove8/cohorts/woofz_offer/woofz_offer2_75/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PAW_NUP } from 'nove8/cohorts/woofz_paw_nup/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPDAY_65 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_65/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPDAY_70 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_70/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPDAY_75 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_75/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPDAY_80 } from 'nove8/cohorts/woofz_ppday/woofz_ppday_80/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPP } from 'nove8/cohorts/woofz_ppp/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPP_BL } from 'nove8/cohorts/woofz_ppp_bl/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPP_WOOFY } from 'nove8/cohorts/woofz_ppp_woofy/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PT1 } from 'nove8/cohorts/woofz_pt1/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PT1_BG } from 'nove8/cohorts/woofz_pt1_bg/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PUP } from 'nove8/cohorts/woofz_pup/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PUP_BL } from 'nove8/cohorts/woofz_pup_bl/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PUP_DRSL } from 'nove8/cohorts/woofz_pup_drsl/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_PUP_WT } from 'nove8/cohorts/woofz_pup_wt/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_RFND3 } from 'nove8/cohorts/woofz_rfnd3/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_RFND3_ND } from 'nove8/cohorts/woofz_rfnd3_nd/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_RT } from 'nove8/cohorts/woofz_rt/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_S1612 } from 'nove8/cohorts/woofz_s/woofz_s1_6_12/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_S2612 } from 'nove8/cohorts/woofz_s/woofz_s2_6_12/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_S3612 } from 'nove8/cohorts/woofz_s/woofz_s3_6_12/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_SMD } from 'nove8/cohorts/woofz_smd/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_SMD_BL } from 'nove8/cohorts/woofz_smd_bl/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_SUB_CNLD_70 } from 'nove8/cohorts/woofz_sub_cnld_70/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_VC6 } from 'nove8/cohorts/woofz_vc6/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_VDAY_65 } from 'nove8/cohorts/woofz_vday/woofz_vday_65/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_VDAY_70 } from 'nove8/cohorts/woofz_vday/woofz_vday_70/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_VDAY_75 } from 'nove8/cohorts/woofz_vday/woofz_vday_75/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_VDAY_80 } from 'nove8/cohorts/woofz_vday/woofz_vday_80/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_VGS } from 'nove8/cohorts/woofz_vgs/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_WA1 } from 'nove8/cohorts/woofz_wa1/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_WOOFY } from 'nove8/cohorts/woofz_woofy1/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_WS2 } from 'nove8/cohorts/woofz_ws2/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_XMAS_65 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_65/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_XMAS_70 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_70/constants/pages-configs-map'
import { ID_TO_PAGE_CONFIG_MAP_WOOFZ_XMAS_80 } from 'nove8/cohorts/woofz_xmas/woofz_xmas_80/constants/pages-configs-map'
import { THEMES } from 'root-constants'
import { PageId } from './pages'

export const ID_TO_PAGE_CONFIG_MAP: TIdToPageConfigMap = {
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ22_V3,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_ESA,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_WS2,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_RT,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_VGS,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_RFND3_ND,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PT1,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_22V4,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_22V4_WT,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_RFND3,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPP,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPP_BL,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPP_WOOFY,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PUP,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PUP_BL,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_LOVE,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_22V4T,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_LOVE_BL,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_INVX,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_VC6,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_WA1,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_EASTER_65,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_EASTER_70,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_EASTER_75,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_EASTER_80,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_S1612,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_S2612,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_S3612,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_K9,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_NPDAY_65,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_NPDAY_70,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_NPDAY_75,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_NPDAY_80,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_K9_BL,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_K9_DRSL,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPDAY_65,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_XMAS_65,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_XMAS_70,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_XMAS_80,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPDAY_70,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPDAY_75,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPDAY_80,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER1_65,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER1_70,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER1_75,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER1_80,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER2_70,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER2_75,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_VDAY_65,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_VDAY_70,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_VDAY_75,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_VDAY_80,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_HLWN_65,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_HLWN_70,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_HLWN_75,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_HLWN_80,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_SUB_CNLD_70,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD_65,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD_70,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD_75,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_NDD_80,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_WOOFY,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_NRDAY_65,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_NRDAY_70,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_NRDAY_75,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_NRDAY_80,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PUP_WT,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PUP_DRSL,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_COACHING,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PAW_NUP,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_SMD,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_SMD_BL,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_22V4_BG,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_PT1_BG,
  ...ID_TO_PAGE_CONFIG_MAP_WOOFZ_K9_BL_BG,
  [PageId.SEX_PN]: {
    id: PageId.SEX_PN,
    hasHeader: true,
  },
  [PageId.DOG_AGE_PN]: {
    id: PageId.DOG_AGE_PN,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_PN,
  },
  [PageId.BIGGEST_CHALLENGE_PN]: {
    id: PageId.BIGGEST_CHALLENGE_PN,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_PN,
  },
  [PageId.DOG_BREED_PN]: {
    id: PageId.DOG_BREED_PN,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_PN,
  },
  [PageId.DOG_BREED_ID_PN]: {
    id: PageId.DOG_BREED_ID_PN,
  },
  [PageId.URGE_PN]: {
    id: PageId.URGE_PN,
    hasHeaderBackButton: true,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.TOYS_PN]: {
    id: PageId.TOYS_PN,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_PN,
  },
  [PageId.FEELINGS_PN]: {
    id: PageId.FEELINGS_PN,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_PN,
  },
  [PageId.URGE_2_PN]: {
    id: PageId.URGE_2_PN,
    hasHeaderBackButton: true,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.CHALLENGES_PN]: {
    id: PageId.CHALLENGES_PN,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
    hasHeader: true,
    theme: THEMES.VARIANT_PN,
  },
  [PageId.YELLING_MOMENTS_PN]: {
    id: PageId.YELLING_MOMENTS_PN,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
    theme: THEMES.VARIANT_PN,
  },
  [PageId.REACTION_PN]: {
    id: PageId.REACTION_PN,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
    theme: THEMES.VARIANT_PN,
  },
  [PageId.BARKING_PN]: {
    id: PageId.BARKING_PN,
    progressBar: 'controlled',
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_PN,
  },
  [PageId.IMPROVE_PN]: {
    id: PageId.IMPROVE_PN,
    hasHeaderBackButton: true,
    hasHeader: true,
    theme: THEMES.VARIANT_PN,
  },
  [PageId.FOLLOW_COMMANDS_PN]: {
    id: PageId.FOLLOW_COMMANDS_PN,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
    theme: THEMES.VARIANT_PN,
  },
  [PageId.COMMANDS_61_PN]: {
    id: PageId.COMMANDS_61_PN,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
    theme: THEMES.VARIANT_PN,
  },
  [PageId.COMMANDS_62_PN]: {
    id: PageId.COMMANDS_62_PN,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
    theme: THEMES.VARIANT_PN,
  },
  [PageId.COMMANDS_63_PN]: {
    id: PageId.COMMANDS_63_PN,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    hasHeader: true,
    theme: THEMES.VARIANT_PN,
  },
  [PageId.URGE_3_PN]: {
    id: PageId.URGE_3_PN,
    hasHeaderBackButton: true,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.URGE_4_PN]: {
    id: PageId.URGE_4_PN,
    hasHeaderBackButton: true,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.FREQUENCY_PN]: {
    id: PageId.FREQUENCY_PN,
    hasHeaderBackButton: true,
    hasHeader: true,
    progressBar: 'controlled',
    theme: THEMES.VARIANT_PN,
  },
  [PageId.PREPARE_FLOW_PN]: {
    id: PageId.PREPARE_FLOW_PN,
    hasHeaderBackButton: true,
    hasHeader: true,
    theme: THEMES.VARIANT_PN,
  },
  [PageId.DOG_STATISTICS_PN]: {
    id: PageId.DOG_STATISTICS_PN,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.EMAIL_PN]: {
    id: PageId.EMAIL_PN,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_PN,
  },
  [PageId.LAST_CHANCE_OFFER_PN]: {
    id: PageId.LAST_CHANCE_OFFER_PN,
    hasHeader: true,
    theme: THEMES.VARIANT_PN,
  },
  [PageId.SUBSCRIPTIONS_PN]: {
    id: PageId.SUBSCRIPTIONS_PN,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_PN]: {
    id: PageId.CHAT_UPSELL_PN,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_PN]: {
    id: PageId.UPSELL_PN,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_PN]: {
    id: PageId.DOWNLOAD_PN,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.NEWSLETTER_URGE_PN]: {
    id: PageId.NEWSLETTER_URGE_PN,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.VARIANT_PN,
  },
  [PageId.SEX_V4L]: {
    id: PageId.SEX_V4L,
    hasHeader: true,
    progressBar: 'controlled',
  },
  [PageId.DOG_AGE_V4L]: {
    id: PageId.DOG_AGE_V4L,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.DOG_BREED_V4L]: {
    id: PageId.DOG_BREED_V4L,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.URGE_V4L]: {
    id: PageId.URGE_V4L,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.COMMANDS_61_V4L]: {
    id: PageId.COMMANDS_61_V4L,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.COMMANDS_62_V4L]: {
    id: PageId.COMMANDS_62_V4L,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.COMMANDS_63_V4L]: {
    id: PageId.COMMANDS_63_V4L,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.URGE_2_V4L]: {
    id: PageId.URGE_2_V4L,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.POTTY_V4L]: {
    id: PageId.POTTY_V4L,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.BEHAVIOR_V4L]: {
    id: PageId.BEHAVIOR_V4L,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.TRAINING_V4L]: {
    id: PageId.TRAINING_V4L,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.PREPARE_FLOW_V4L]: {
    id: PageId.PREPARE_FLOW_V4L,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.DOG_STATISTICS_V4L]: {
    id: PageId.DOG_STATISTICS_V4L,
    hasHeader: true,
    theme: THEMES.URGE,
  },
  [PageId.EMAIL_V4L]: {
    id: PageId.EMAIL_V4L,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.NEWSLETTER_URGE_V4L]: {
    id: PageId.NEWSLETTER_URGE_V4L,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageId.CHAT_UPSELL_V4L]: {
    id: PageId.CHAT_UPSELL_V4L,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_V4L]: {
    id: PageId.UPSELL_V4L,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_PITPAT_V4L]: {
    id: PageId.UPSELL_PITPAT_V4L,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_V4L]: {
    id: PageId.DOWNLOAD_V4L,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.SUBSCRIPTIONS_V4L_2]: {
    id: PageId.SUBSCRIPTIONS_V4L_2,
  },
  [PageId.LAST_CHANCE_OFFER_V4L]: {
    id: PageId.LAST_CHANCE_OFFER_V4L,
  },
  [PageId.PREPARE_FLOW_V9]: {
    hasHeader: true,
    id: PageId.PREPARE_FLOW_V9,
    theme: 'variant_v9',
  },
  [PageId.EMAIL_V9]: {
    hasHeader: true,
    id: PageId.EMAIL_V9,
    theme: 'variant_v9',
  },
  [PageId.SUBSCRIPTIONS_V9]: {
    id: PageId.SUBSCRIPTIONS_V9,
  },
  [PageId.CANCEL_OFFER_V9]: {
    hasHeader: false,
    id: PageId.CANCEL_OFFER_V9,
  },
  [PageId.DOWNLOAD_V9]: {
    id: PageId.DOWNLOAD_V9,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOG_BREED_V9]: {
    progressBar: 'controlled',
    hasHeader: true,
    theme: 'variant_v9',
    id: PageId.DOG_BREED_V9,
  },
  [PageId.DOG_BREED_ID_V9]: {
    id: PageId.DOG_BREED_ID_V9,
  },
  [PageId.COMMANDS_61_V9]: {
    progressBar: 'controlled',
    hasHeader: true,
    id: PageId.COMMANDS_61_V9,
    theme: 'variant_v9',
  },
  [PageId.COMMANDS_62_V9]: {
    progressBar: 'controlled',
    hasHeader: true,
    id: PageId.COMMANDS_62_V9,
    theme: 'variant_v9',
  },
  [PageId.COMMANDS_63_V9]: {
    progressBar: 'controlled',
    hasHeader: true,
    id: PageId.COMMANDS_63_V9,
    theme: 'variant_v9',
  },
  [PageId.COMMANDS_64_V9]: {
    progressBar: 'controlled',
    hasHeader: true,
    id: PageId.COMMANDS_64_V9,
    theme: 'variant_v9',
  },
  [PageId.URGE_V9]: {
    id: PageId.URGE_V9,
    theme: 'variant_v9',
    hasHeader: true,
  },
  [PageId.URGE_2_V9]: {
    id: PageId.URGE_2_V9,
    theme: 'urge',
    hasHeader: true,
  },
  [PageId.CONGRATS_V9]: {
    id: PageId.CONGRATS_V9,
    theme: THEMES.CONGRATS_V9,
    hasHeader: true,
  },
  [PageId.SEX_V9]: {
    progressBar: 'controlled',
    hasHeader: true,
    id: PageId.SEX_V9,
    theme: 'variant_v9',
  },
  [PageId.DOG_AGE_V9]: {
    progressBar: 'controlled',
    id: PageId.DOG_AGE_V9,
    hasHeader: true,
    theme: 'variant_v9',
  },
  [PageId.POTTY_V9]: {
    progressBar: 'controlled',
    hasHeader: true,
    id: PageId.POTTY_V9,
    theme: 'variant_v9',
  },
  [PageId.DOG_STATISTICS_V9]: {
    hasHeader: true,
    theme: THEMES.URGE,
    id: PageId.DOG_STATISTICS_V9,
  },
  [PageId.BEHAVIOR_V9]: {
    progressBar: 'controlled',
    hasHeader: true,
    id: PageId.BEHAVIOR_V9,
    theme: 'variant_v9',
  },
  [PageId.TRAINING_V9]: {
    progressBar: 'controlled',
    hasHeader: true,
    id: PageId.TRAINING_V9,
    theme: 'variant_v9',
  },
  [PageId.UPSELL_V9]: {
    id: PageId.UPSELL_V9,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.CHAT_UPSELL_V9]: {
    id: PageId.CHAT_UPSELL_V9,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_PITPAT_V9]: {
    id: PageId.UPSELL_PITPAT_V9,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
